import React from 'react'

import {
  Navigate,
  Route,
  Routes as RouterRoutes,
} from 'react-router-dom'

import {
  AUTHENTICATED_ENTRY,
} from 'configs/AppConfig'

import {
  protectedRoutes,
  publicRoutes,
} from 'configs/RoutesConfig'

import ProtectedRoute from './ProtectedRoute'
import PublicRoute from './PublicRoute'
import AppRoute from './AppRoute'

import PlayPage from 'views/public-views/play'
import ResultPage from 'views/public-views/result'
import OfflinePreparePage from 'views/public-views/offline-prepare'
import PublicGameLobby from 'views/public-views/game-lobby'

// ======================================================
// NOVO - CADASTRO RIVER RACE
// ======================================================

import GameRegistrationPage
  from 'views/public-views/game-registration'


// ======================================================
// LEITOR QR - PROMOTORA
// ======================================================

import QrReaderPage
  from 'views/public-views/qr-reader'


const Routes = () => {
  // ======================================================
  // ROTAS PÚBLICAS NORMAIS
  //
  // Estas rotas são retiradas daqui porque precisam
  // funcionar DIRETAMENTE, mesmo quando o usuário
  // estiver autenticado.
  //
  // /lobby/:eventSlug
  // /play/:slug
  // /join/:publicToken
  // /p/:spinId
  // /r/:type/:id
  // /offline-prepare/:slug
  // ======================================================

  const normalPublicRoutes =
    publicRoutes.filter(
      (route) =>
        route.path !==
        '/lobby/:eventSlug' &&

        route.path !==
        '/play/:slug' &&

        route.path !==
        '/join/:publicToken' &&

        route.path !==
        '/qr-reader' &&

        route.path !==
        '/p/:spinId' &&

        route.path !==
        '/r/:type/:id' &&

        route.path !==
        '/offline-prepare/:slug',
    )


  return (
    <RouterRoutes>

      {/* ================================================== */}
      {/* PÁGINA INICIAL DOS JOGOS */}
      {/* ================================================== */}

      <Route
        path="/lobby/:eventSlug"
        element={
          <AppRoute
            routeKey="game-lobby-direct"
            component={PublicGameLobby}
            blankLayout
          />
        }
      />


      {/* ================================================== */}
      {/* PLAY */}
      {/* ================================================== */}

      <Route
        path="/play/:slug"
        element={
          <AppRoute
            routeKey="play-game-direct"
            component={PlayPage}
            blankLayout
          />
        }
      />


      {/* ================================================== */}
      {/* CADASTRO RIVER RACE / UNITY */}
      {/* ================================================== */}

      <Route
        path="/join/:publicToken"
        element={
          <AppRoute
            routeKey="game-registration-direct"
            component={GameRegistrationPage}
            blankLayout
          />
        }
      />

      {/* ================================================== */}
      {/* LEITOR QR - PROMOTORA */}
      {/* ================================================== */}

      <Route
        path="/qr-reader"
        element={
          <AppRoute
            routeKey="qr-reader-direct"
            component={QrReaderPage}
            blankLayout
          />
        }
      />


      {/* ================================================== */}
      {/* RESULTADO DA ROLETA */}
      {/* ================================================== */}

      <Route
        path="/p/:spinId"
        element={
          <AppRoute
            routeKey="roulette-result-direct"
            component={ResultPage}
            blankLayout
          />
        }
      />


      {/* ================================================== */}
      {/* RESULTADO GENÉRICO DOS JOGOS */}
      {/* ================================================== */}

      <Route
        path="/r/:type/:id"
        element={
          <AppRoute
            routeKey="game-result-direct"
            component={ResultPage}
            blankLayout
          />
        }
      />


      {/* ================================================== */}
      {/* PREPARAÇÃO OFFLINE */}
      {/* ================================================== */}

      <Route
        path="/offline-prepare/:slug"
        element={
          <AppRoute
            routeKey="offline-prepare-direct"
            component={OfflinePreparePage}
            blankLayout
          />
        }
      />


      {/* ================================================== */}
      {/* RAIZ */}
      {/* ================================================== */}

      <Route
        path="/"
        element={
          <Navigate
            replace
            to={
              AUTHENTICATED_ENTRY
            }
          />
        }
      />


      {/* ================================================== */}
      {/* ROTAS PÚBLICAS NORMAIS */}
      {/* ================================================== */}

      <Route
        element={
          <PublicRoute />
        }
      >
        {
          normalPublicRoutes.map(
            (route) => (
              <Route
                key={
                  route.path
                }
                path={
                  route.path
                }
                element={
                  <AppRoute
                    routeKey={
                      route.key
                    }
                    component={
                      route.component
                    }
                    {...route.meta}
                  />
                }
              />
            ),
          )
        }
      </Route>


      {/* ================================================== */}
      {/* ROTAS PROTEGIDAS */}
      {/* ================================================== */}

      <Route
        element={
          <ProtectedRoute />
        }
      >
        {
          protectedRoutes.map(
            (
              route,
              index,
            ) => (
              <Route
                key={
                  route.key +
                  index
                }
                path={
                  route.path
                }
                element={
                  <AppRoute
                    routeKey={
                      route.key
                    }
                    component={
                      route.component
                    }
                    {...route.meta}
                  />
                }
              />
            ),
          )
        }
      </Route>


      {/* ================================================== */}
      {/* FALLBACK */}
      {/* ================================================== */}

      <Route
        path="*"
        element={
          <Navigate
            to={
              AUTHENTICATED_ENTRY
            }
            replace
          />
        }
      />

    </RouterRoutes>
  )
}


export default Routes